<template>
    <Modal class="ad-unit-pending-approval-modal"
           :version="1"
           v-on="listeners"
           open
           :title="title"
           :showCancelButton="false"
           :showCloseButton="false"
           :clickOutsideClose="false"
           :showFooterSeparator="false"
           okButtonText="Got It">
        <div slot="modal-header" class="modal-header">
            <IconBase iconName="birdIcon"
                      :width="birdIcon.width"
                      :height="birdIcon.height"
            ></IconBase>
            <div class="modal-title font-3">
                You're almost done
            </div>
        </div>
        <span slot="modal-body" class="modal-body">
            Check your inbox. An ironSource representative will be in touch soon to help you go live. <br/>
            <br/>
            You can already start testing your integration to see how the ads you activated will look on your app.
            <br/>
            <a :href="link" target="_blank"> Learn how &#x00BB; </a>
        </span>
    </Modal>
</template>

<script>
import Modal from 'components/modals/Modal.vue';
import IconBase from 'components/IconBase.vue';
import links from 'services/metaData/links';
import Vue from 'vue';

const localStorageKey = 'seenAdUnitsPendingApprovalModal';

export default {
    name: 'PendingApprovalModal',
    components: { IconBase, Modal },
    data() {
        return {
            link: links.integrationTesting,
            birdIcon: {
                width: 111,
                height: 89
            }
        };
    },
    computed: {
        listeners() {
            // we bind the @ok listener to override it and emit an ok event with arguments (the component data)
            return { ...this.$listeners, ok: this.emitOk };
        },
    },
    methods: {
        emitOk() {
            // save in local storage
            localStorage.setItem(localStorageKey, JSON.stringify(true));
            this.$emit('ok');
        },
        showModal() {
            Vue.prototype.$modal.openPendingApprovalModal();
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide";
@import "~styles/buttons.scss";

.ad-unit-pending-approval-modal.v1 ::v-deep .modal-container {
    width: 400px;
    height: 345px;
}

.ad-unit-pending-approval-modal.v1 ::v-deep .modal-footer {
    background-color: $white;
}

.ad-unit-pending-approval-modal.v1 ::v-deep .modal-title {
    padding-top: 16px;
}

.ad-unit-pending-approval-modal.v1 ::v-deep .modal-body {
    margin-bottom: 13px;
    margin-top: 16px;
}

.ad-unit-pending-approval-modal.v1 ::v-deep button.primary {
    margin-right: 30px;
    margin-bottom: 10px;
    margin-top: -11px;
}

.modal-header {
    margin-top: 12px;
}

.modal-body {
    color: $light-900;
    line-height: normal;
}
</style>
